export type MovementAction = {
  id: string;
  fromLocationTypeId: string;
  toLocationTypeId: string;
  inventoryAttribute: string;
  modificationType: string;
  modificationValue: string;
  fromLocationType?: {
    id: string;
    name: string;
  };
  toLocationType?: {
    id: string;
    name: string;
  };
};

export const defaultMovementAction: MovementAction = {
  id: "",
  fromLocationTypeId: "",
  toLocationTypeId: "",
  inventoryAttribute: "",
  modificationType: "",
  modificationValue: "",
};
